// extracted by mini-css-extract-plugin
export var card = "_m1-0";
export var content = "_m1-2";
export var details = "_m1-3";
export var icon = "_m1-1";
export var iconBlue = "_m1-5";
export var iconBrand = "_m1-4";
export var iconGrayBlue = "_m1-6";
export var iconGreen = "_m1-7";
export var iconIndigo = "_m1-8";
export var iconOrange = "_m1-9";
export var iconPurple = "_m1-a";
export var iconRed = "_m1-b";
export var iconWarning = "_m1-c";